import {
  FETCH_PRICE_AUDIT_REQUEST,
  FETCH_PRICE_AUDIT_SUCCESS,
  FETCH_PRICE_AUDIT_FAILURE,
} from "../actions/csvPriceAuditAction";

const initialState = {
  data: [],
  loading: false,
  error: null,

  totalCount: 0,
  totalPages: 0,
  currentPage: 1,
  hasNextPage: false,
};

const priceAuditReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRICE_AUDIT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_PRICE_AUDIT_SUCCESS: {
      const { results, count, next, previous, page, page_size } =
        action.payload;

      const isFirstPage = page === 1;
      const hasNextPage = next;

      return {
        ...state,
        loading: false,
        error: null,

        data: isFirstPage ? results : [...state.data, ...results],

        totalCount: count,
        totalPages: Math.ceil(count / page_size),
        currentPage: page,
        hasNextPage,
      };
    }

    case FETCH_PRICE_AUDIT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default priceAuditReducer;
